import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { withTranslation, Trans } from 'react-i18next';
import TextTooltipOnHover from '../../../Tooltip/TextTooltipOnHover';
import { IconSize } from '../../../Icons/IconWrap';
import ChangeIcon from '../../../Icons/Change';
import CameraIcon from '../../../Icons/Camera';
import TrashcanIcon from '../../../Icons/Trashcan';
import Button from '../../../Button';
import MediaSelector from '../../../MediaPopup/MediaSelector';
import { MediaSourceType } from '../../../MediaPopup/types';
import { DeviationTypes } from '../../../types/deviation';
import { ThemeOptions } from '../../../publicSession';
import s from '../CoverImage.scss';
var defaultState = {
    showMediaSelector: false,
};
var CoverImageControls = /** @class */ (function (_super) {
    tslib_1.__extends(CoverImageControls, _super);
    function CoverImageControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = defaultState;
        _this.toogleFirstFlag = function () {
            var recordFirstTimeUse = _this.props.recordFirstTimeUse;
            recordFirstTimeUse();
        };
        _this.renderRemoveCoverImageButton = function () {
            var t = _this.props.t;
            return (React.createElement("span", { className: s['delete-btn-wrapper'] },
                React.createElement(TextTooltipOnHover, { forceTheme: ThemeOptions.LIGHT, tooltipOffset: '0, 4', tooltipText: t('writer.removeCoverImage'), renderReference: function (_a) {
                        var ref = _a.ref;
                        return (React.createElement(Button, { className: s['controls-button'], view: "b19", onClick: _this.removeCoverDeviation },
                            React.createElement(TrashcanIcon, { className: s['icon'], size: IconSize.MEDIUM, containerRef: ref, condensed: true })));
                    } })));
        };
        _this.renderUpdateCoverImageButton = function (tooltipRef) {
            var _a = _this.props, deviation = _a.deviation, t = _a.t, isEnableTooltip = _a.isEnableTooltip;
            var hasCoverImage = deviation !== undefined;
            return (React.createElement("div", { className: classnames(isEnableTooltip && !hasCoverImage && s['grow']) },
                React.createElement(Button, { className: s['controls-button'], view: "b19", onClick: _this.showMediaSelector },
                    React.createElement("span", { className: s['icon-btn-content'] },
                        hasCoverImage && (React.createElement(ChangeIcon, { className: s['icon'], size: IconSize.MEDIUM, containerRef: tooltipRef, condensed: true })),
                        !hasCoverImage && (React.createElement(CameraIcon, { className: s['icon'], size: IconSize.MEDIUM, containerRef: tooltipRef, condensed: true })),
                        React.createElement("span", { className: s['btn-title'] },
                            hasCoverImage && t('writer.editCoverImage'),
                            !hasCoverImage && t('writer.addCoverImage'))))));
        };
        _this.showMediaSelector = function () {
            _this.setState({ showMediaSelector: true });
        };
        _this.hideMediaSelector = function () {
            _this.setState({ showMediaSelector: false });
        };
        _this.updateCoverDeviation = function (items) {
            var deviation = items[0];
            if (deviation) {
                _this.props.onChange && _this.props.onChange(deviation);
            }
            _this.hideMediaSelector();
        };
        _this.removeCoverDeviation = function () {
            _this.props.onChange && _this.props.onChange(undefined);
        };
        return _this;
    }
    CoverImageControls.prototype.render = function () {
        var _this = this;
        var _a = this.props, showToolTip = _a.showToolTip, deviation = _a.deviation, className = _a.className, isEnableTooltip = _a.isEnableTooltip;
        var hasCoverImage = deviation !== undefined;
        return (React.createElement("div", { className: classnames(s['controls'], className) },
            hasCoverImage && this.renderRemoveCoverImageButton(),
            showToolTip && isEnableTooltip ? (React.createElement(TextTooltipOnHover, { contentClassName: s['tooltip'], forceTheme: ThemeOptions.LIGHT, tooltipOffset: '0, 4', tooltipText: React.createElement(Trans, { i18nKey: "writer.tooltipCoverImage" },
                    'Make your journal stand out with a cover image.',
                    React.createElement("div", null,
                        React.createElement(Button, { view: "b34", onClick: this.toogleFirstFlag, className: s['gotit'] }, "Got it"))), renderReference: function (_a) {
                    var ref = _a.ref;
                    return _this.renderUpdateCoverImageButton(ref);
                } })) : (this.renderUpdateCoverImageButton()),
            this.state.showMediaSelector && this.renderMediaSelector()));
    };
    CoverImageControls.prototype.renderMediaSelector = function () {
        return (React.createElement(MediaSelector, { mediaSourceTypes: [MediaSourceType.GALLERY, MediaSourceType.STASH], allowedDeviationTypes: [DeviationTypes.IMAGE], allowGifs: false, minDeviationWidth: 1024, minDeviationHeight: 630, onClose: this.hideMediaSelector, onSelect: this.updateCoverDeviation }));
    };
    return CoverImageControls;
}(React.Component));
export { CoverImageControls };
var enhance = compose(withTranslation());
export default enhance(CoverImageControls);
//# sourceMappingURL=CoverImageControls.js.map